import React from "react";
import { useSelector } from "react-redux";
import EditBrandModelDialogComponent from './editBrandModelDialog.component';
import {canAccess} from "../../../../profile/redux/selector/profile.selector";
import {AccessRights} from "../../../../../lib/constants/accessRights";

export default function EditBrandModelDialogContainer({
  isOpen,
  handleClose,
  handleSubmit,
  data,
  isSaving,
}) {
  const lang = useSelector(state => state.constant.languages)
  const canEditName = useSelector(state =>
    canAccess(state, AccessRights.Product.BRAND_MODEL_UPDATE_BRAND_NAME));
  const canEditDescription = useSelector(state =>
    canAccess(state, AccessRights.Product.BRAND_MODEL_UPDATE_DESCRIPTION));
  const canEditStatus = useSelector(state =>
    canAccess(state, AccessRights.Product.BRAND_MODEL_UPDATE_STATUS));
  const canEditImage = useSelector(state =>
    canAccess(state, AccessRights.Product.BRAND_MODEL_UPDATE_BRAND_IMAGE));
  const canEditModel = useSelector(state =>
    canAccess(state, AccessRights.Product.BRAND_MODEL_UPDATE_MODELS));

  return (
    <EditBrandModelDialogComponent
      handleClose={handleClose}
      handleSubmit={handleSubmit}
      isOpen={isOpen}
      data={data}
      lang={lang}
      isSaving={isSaving}
      canEditName={canEditName}
      canEditDescription={canEditDescription}
      canEditStatus={canEditStatus}
      canEditImage={canEditImage}
      canEditModel={canEditModel}
    />
  )
}
